<template>
  <container-loader v-if="!loaded"></container-loader>
  <div v-else-if="errorMessage!==null"></div>
  <div v-else>
    <div class="modal--notes__wrapper">
      <div class="modal--notes__item modal--notes__item--qa" v-if="qa !== null">
        <div class="modal--notes__item__meta text--muted">{{$t('printers.modal.jobNotes.qa')}}</div>
        <div class="modal--notes__item__body" v-for="(q, index) in qaList" :key="index">
          <strong>{{index+1}}. {{q.name}}</strong>
          <br />
          <ul>
            <li v-for="(a, aIndex) in q.answers" :key="aIndex">
              <span>{{a.label}}: </span>
              <span v-if="a.values.length === 1">{{a.values[0]}}</span>
              <ul v-else>
                <li v-for="(value, vIndex) in a.values" :key="vIndex">{{value}}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div v-for="(note, index) in notes"
           :key="index"
           class="modal--notes__item"
           :class="{'modal--notes__item--my': note.myself==='t'}"
      >
        <div class="modal--notes__item__meta">
          {{note.user}}
          <date-time-text class="text--muted text--xsmall" :date="note.datetime_f"></date-time-text>
        </div>
        <div class="modal--notes__item__body">
          <span class="text--muted">{{noteType(note.feedback)}}: </span>
          {{note.note}}
        </div>
      </div>
    </div>
    <b-form class="form form--inline form--notes">
      <b-textarea class="txtar" v-model="noteValue" :placeholder="$t('printers.modal.jobNotes.notePlaceholder')"></b-textarea>
      <div style="margin-left: 15px;">
        <select class="sel inp" v-model="typeValue">
          <option value="note">{{$t('printers.modal.jobNotes.types.note')}}</option>
          <option value="feedback">{{$t('printers.modal.jobNotes.types.feedback')}}</option>
        </select>
      </div>
      <b-button variant="-primary" :disabled="processing" @click="handleAddNote">
        <b-spinner v-if="processing" small type="grow"></b-spinner>{{$t('printers.modal.jobNotes.addNote')}}
      </b-button>
    </b-form>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import DateTimeText from "../../DateTimeText";

  export default {
    name: 'job-notes',
    components: {DateTimeText},
    props: ['jobId'],
    data() {
      return {
        loaded: false,
        processing: false,
        qa: null,
        notes: [],
        errorMessage: null,

        noteValue: '',
        typeValue: 'note'
      }
    },
    created() {
      this.loadNotes();
    },
    computed: {
      qaList() {
        if (!this.qa) {
          return [];
        }
        let result = [];
        for (let i in this.qa) {
          const question = this.qa[i];
          let data = {name: question.name, answers: []};
          if (question.answers && question.answers.length) {
            for (let a in question.answers) {
              if (question.answers[a].value) {
                data.answers.push({
                  label: question.answers[a].label,
                  values: question.answers[a].value.split(',')
                });
              }
            }
          }
          result.push(data);
        }

        return result;
      }
    },
    methods: {
      ...mapActions(['getJobNotes', 'addJobNote']),

      noteType(isFeedback) {
        if (isFeedback === 't') {
          return this.$t('printers.modal.jobNotes.types.feedback');
        }

        return this.$t('printers.modal.jobNotes.types.note')
      },
      loadNotes(scrollDown) {
        this.getJobNotes(this.jobId).then(({data}) => {
          this.loaded = true;
          if (data.result) {
            if (typeof data.message.qa === 'object') {
              this.qa = data.message.qa;
            } else {
              this.qa = null;
            }
            this.notes = data.message.notes;
            if (scrollDown) {
              setTimeout(() => {
                const container = this.$el.querySelector(".modal--notes__wrapper");
                container.scrollTop = container.scrollHeight;
              }, 100);
            }
          } else {
            this.errorMessage = data.message;
          }
        }).catch(() => {
          this.loaded = true;
          this.errorMessage = this.$t('printers.modal.jobNotes.errorLoadingNotes');
        })
      },
      handleAddNote() {
        this.processing = true;
        this.addJobNote({jobId: this.jobId, note: this.noteValue, isFeedback: this.typeValue === 'feedback'})
          .then(({data}) => {
            this.processing = false;
            if (data.result) {
              this.noteValue = '';
              this.typeValue = 'note';
              this.loadNotes(true);
            } else {
              this.msgBoxOk(data.message);
            }
          })
          .catch(() => {
            this.msgBoxOk(this.$t('printers.modal.jobNotes.errorAddNote'));
          });
      }
    }
  }
</script>
<style lang="scss">
  select{
    border: 1px solid #c3d2da !important;
  }
</style>
